"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = void 0;
var _i18n = require("../services/i18n");
const i18n = exports.i18n = {
  init: _i18n.init
};